import React, { FC } from 'react';
import {
  createStyles,
  makeStyles,
  createMuiTheme,
} from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import accounting from 'accounting';

import {
  ListItemAvatar, Avatar, Typography, Box,
} from '@material-ui/core';

const useStyles = makeStyles(() => createStyles({
  item: {
    color: 'black',
    display: 'inline',
  },
}));

export type ProductModel = {
  type: 'product';
  image: string;
  longDescription: string;
  price: number;
};

interface ProductItemProps {
  model: ProductModel;
  onProductClick?: (product: any) => void;
}

const ProductTableItem: FC<ProductItemProps> = (props) => {
  const theme = createMuiTheme();
  const classes = useStyles(theme);
  return (
    <ListItem
      button
      onClick={() => {
        // history.push(`/details/${product.inRutaCode}`);
        // props?.onProductClick(props.product);
      }}
    >
      <ListItemAvatar>
        <Avatar alt={props?.model.longDescription} src={props?.model.image} />
      </ListItemAvatar>
      <ListItemText
        disableTypography
        primary={(
          <Box display="flex">
            <Typography className={classes.item}>
              {props?.model.longDescription}
            </Typography>
            <Box className={classes.item} flexGrow={1} />
            <Typography className={classes.item}>
              {accounting.formatMoney(props?.model.price)}
            </Typography>
          </Box>
        )}
      />
    </ListItem>
  );
};

export default ProductTableItem;
